/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon24Regular = forwardRef('ArrowADownIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.125 19.816V3a.875.875 0 0 1 1.75 0v16.816c.034-.027.066-.057.097-.088l6.284-6.284a.875.875 0 1 1 1.238 1.237l-6.284 6.284a3.125 3.125 0 0 1-4.42 0l-6.284-6.284a.875.875 0 1 1 1.238-1.237l6.284 6.284c.031.031.063.06.097.088Z" })));
});
